import { render, staticRenderFns } from "./slogan.vue?vue&type=template&id=d7a1159e&scoped=true&"
import script from "./slogan.vue?vue&type=script&lang=js&"
export * from "./slogan.vue?vue&type=script&lang=js&"
import style0 from "./slogan.vue?vue&type=style&index=0&id=d7a1159e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a1159e",
  null
  
)

export default component.exports